import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import moment from 'moment';
import { Box, Dialog, DialogActions, DialogContent as MuiDialogContent, DialogTitle, FormControl, Grid, IconButton, InputAdornment as MuiInputAdornment, Typography, withStyles } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import { KailonaButton, KailonaDateTimePicker, KailonaTextField, KailonaSelect } from '@kailona/ui';
import { getGlucoseMeasurer, GlucoseSystemCodes } from '../lib/GlucoseSystemCodes';
var GridColumn = withStyles({
  root: {
    '&.left-column': {
      margin: '10px 10px 10px 0',
      width: '180px'
    },
    '&.right-column': {
      margin: '10 0px 10px 10px',
      width: '180px'
    },
    '& > .MuiFormControl-root': {
      width: '100%'
    }
  }
})(Grid);
var DialogContent = withStyles({
  root: {
    height: '100%',
    margin: '0 20px 20px 20px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #EAEAEA',
    borderRadius: '5px',
    paddingBottom: '25px'
  }
})(MuiDialogContent);
var InputAdornment = withStyles({
  root: {
    '& p': {
      fontSize: '10px'
    }
  }
})(MuiInputAdornment);
var styles = {
  uneditable: {
    container: {
      display: 'flex',
      alignItems: 'center'
    },
    value: {
      margin: '0 10px',
      borderBottom: '1px dashed #3F51B5',
      minWidth: '15px'
    },
    unit: {
      fontSize: '10px',
      color: '#999999'
    }
  }
};

var DiabetesEditModal = /*#__PURE__*/function (_Component) {
  _inherits(DiabetesEditModal, _Component);

  var _super = _createSuper(DiabetesEditModal);

  function DiabetesEditModal(props) {
    var _this;

    _classCallCheck(this, DiabetesEditModal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function (isOpen) {
      _this.setState({
        isOpen: isOpen
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onConfirm", function () {
      var newDiabetes = {
        date: moment(_this.dateRef.current.value),
        glucoseValue: _this.glucoseValueRef.current.value,
        glucoseSystem: _this.glucoseSystemRef.current.value
      };
      var diabetes = _this.props.diabetes;

      _this.props.handleSave(Object.assign({}, diabetes || {}, newDiabetes));
    });

    _defineProperty(_assertThisInitialized(_this), "getValue", function (text) {
      if (!text || !text.split) {
        return text || '';
      }

      var _text$split = text.split(' '),
          _text$split2 = _slicedToArray(_text$split, 1),
          value = _text$split2[0];

      return value;
    });

    _defineProperty(_assertThisInitialized(_this), "getUnit", function (text) {
      if (!text || !text.split) {
        return text || '';
      }

      var _text$split3 = text.split(' '),
          _text$split4 = _slicedToArray(_text$split3, 2),
          unit = _text$split4[1];

      return unit;
    });

    _this.state = {
      isOpen: false
    };
    _this.dateRef = /*#__PURE__*/React.createRef();
    _this.glucoseValueRef = /*#__PURE__*/React.createRef();
    _this.glucoseSystemRef = /*#__PURE__*/React.createRef();
    _this.glucoseMeasurerOptions = Object.keys(GlucoseSystemCodes).map(function (k) {
      return {
        value: k,
        text: getGlucoseMeasurer(k)
      };
    });
    return _this;
  }

  _createClass(DiabetesEditModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _ref = this.props.diabetes || {},
          date = _ref.date,
          glucoseValue = _ref.glucoseValue,
          _ref$glucoseSystem = _ref.glucoseSystem,
          glucoseSystem = _ref$glucoseSystem === void 0 ? 'capillaryBloodByGlucometer' : _ref$glucoseSystem;

      return /*#__PURE__*/React.createElement(Dialog, {
        open: this.state.isOpen,
        onClose: function onClose() {
          return _this2.toggleModal(false);
        }
      }, /*#__PURE__*/React.createElement(DialogTitle, null, /*#__PURE__*/React.createElement(Box, {
        display: "flex",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Box, {
        flexGrow: 1
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h3"
      }, t('ehr', this.props.diabetes ? 'Update Diabetes Data' : 'Add Diabetes Data'))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(IconButton, {
        onClick: function onClick() {
          return _this2.toggleModal(false);
        }
      }, /*#__PURE__*/React.createElement(CloseIcon, null))))), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaDateTimePicker, {
        inputRef: this.dateRef,
        id: "date",
        ariaLabel: t('ehr', 'Select Date/Time'),
        defaultValue: date ? moment(date) : null,
        onChange: this.onInputDataChanged
      }))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(GridColumn, {
        className: "left-column",
        item: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaTextField, {
        inputRef: this.glucoseValueRef,
        type: "number",
        id: "glucoseValue",
        className: "kailona-MuiTextField",
        label: t('ehr', 'Glucose Value'),
        defaultValue: this.getValue(glucoseValue),
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, null, this.getUnit(glucoseValue) || 'mmol/L')
        },
        onChange: this.onInputDataChanged
      }))), /*#__PURE__*/React.createElement(GridColumn, {
        className: "right-column",
        item: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaSelect, {
        inputRef: this.glucoseSystemRef,
        id: "glucoseMeasurer",
        className: "kailona-MuiTextField",
        name: t('ehr', 'Glucose Measurer'),
        defaultValue: glucoseSystem,
        options: this.glucoseMeasurerOptions,
        onChange: this.onInputDataChanged
      })))))), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(KailonaButton, {
        title: t('ehr', 'Cancel'),
        class: "default",
        disabled: this.props.savingDiabetes,
        onClick: function onClick() {
          return _this2.toggleModal(false);
        }
      }), /*#__PURE__*/React.createElement(KailonaButton, {
        title: t('ehr', 'Confirm'),
        class: "primary",
        disabled: this.props.savingDiabetes,
        onClick: this.onConfirm,
        loading: this.props.savingDiabetes
      })));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return DiabetesEditModal;
}(Component);

export { DiabetesEditModal as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(GridColumn, "GridColumn", "/home/runner/html/nextcloud/apps/ehr/js/plugins/diabetes/src/components/DiabetesEditModal.js");
  reactHotLoader.register(DialogContent, "DialogContent", "/home/runner/html/nextcloud/apps/ehr/js/plugins/diabetes/src/components/DiabetesEditModal.js");
  reactHotLoader.register(InputAdornment, "InputAdornment", "/home/runner/html/nextcloud/apps/ehr/js/plugins/diabetes/src/components/DiabetesEditModal.js");
  reactHotLoader.register(styles, "styles", "/home/runner/html/nextcloud/apps/ehr/js/plugins/diabetes/src/components/DiabetesEditModal.js");
  reactHotLoader.register(DiabetesEditModal, "DiabetesEditModal", "/home/runner/html/nextcloud/apps/ehr/js/plugins/diabetes/src/components/DiabetesEditModal.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();